import React from 'react'
import { Typography } from '@mui/material'

export const highlightRenderer = (key, result) => {
  return (
    <Typography
      variant="paragraph3"
      sx={{ backgroundColor: 'secondary.main' }}
      key={key}
    >
      {result[0]}
    </Typography>
  )
}
